export default "__VITE_ASSET__ddae89c6__"